import { render, staticRenderFns } from "./EditChannelOuterId.vue?vue&type=template&id=1b8226ef&scoped=true"
import script from "./EditChannelOuterId.vue?vue&type=script&lang=js"
export * from "./EditChannelOuterId.vue?vue&type=script&lang=js"
import style0 from "./EditChannelOuterId.vue?vue&type=style&index=0&id=1b8226ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8226ef",
  null
  
)

export default component.exports